import React, { useEffect, useRef } from 'react';

interface WelcomeModalProps {
  isOpen: boolean;
  onClose: () => void;
  username: string;
}

const WelcomeModal: React.FC<WelcomeModalProps> = ({
  isOpen,
  onClose,
  username,
}) => {
  const modal = useRef<HTMLDivElement>(null);

  const handleClose = () => {
    onClose();
  };

  useEffect(() => {
    const clickHandler = (event: MouseEvent) => {
      if (modal.current && !modal.current.contains(event.target as Node)) {
        handleClose();
      }
    };
    document.addEventListener('mousedown', clickHandler);
    return () => document.removeEventListener('mousedown', clickHandler);
  }, [isOpen, onClose]);

  useEffect(() => {
    const keyHandler = ({ keyCode }: KeyboardEvent) => {
      if (isOpen && (keyCode === 27 || keyCode === 13)) {
        handleClose();
      }
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className={`fixed left-0 top-0 z-999999 flex h-full w-full items-center justify-center bg-black/50 px-4 py-5 dark:bg-black/70 ${
        isOpen ? 'block' : 'hidden'
      }`}
    >
      <div
        ref={modal}
        className="w-full max-w-lg rounded-lg bg-white p-8 text-center shadow-lg dark:border dark:border-strokedark dark:bg-boxdark dark:text-white"
      >
        <div className="mb-4 flex justify-center">
          <div className="rounded-full bg-yellow-100 p-3 dark:bg-[#3CA745]/20">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-10 w-10 text-yellow-500 dark:text-[#3CA745]"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M4.93 4.93l1.41 1.41" />
              <path d="M2 12h2" />
              <path d="M4.93 19.07l1.41-1.41" />
              <path d="M12 22v-2" />
              <path d="M19.07 19.07l-1.41-1.41" />
              <path d="M22 12h-2" />
              <path d="M19.07 4.93l-1.41 1.41" />
              <path d="M12 2v2" />
              <circle cx="12" cy="12" r="5" />
            </svg>
          </div>
        </div>

        {/* Título */}
        <h3 className="pb-2 text-2xl font-bold text-gray-800 dark:text-white sm:text-3xl">
          ¡Bienvenido, {username}!
        </h3>
        <span className="mx-auto mb-6 inline-block h-1 w-20 rounded bg-[#3CA745]"></span>

        {/* Botón */}
        <button
          onClick={handleClose}
          className="w-full rounded-lg bg-[#3CA745] py-3 font-medium text-white shadow-lg transition duration-200 hover:bg-[#32953D] dark:bg-[#3CA745] dark:hover:bg-[#2D8237]"
        >
          Empezar
        </button>
      </div>
    </div>
  );
};

export default WelcomeModal;
